import React from "react";
import Header from "../../components/header";
import heroImage from "../../images/image 177.svg";
import { Link as RouterLink } from "react-router-dom";
import { useLoanApply } from "./Component/LoanApplyContext";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const LoanMain = () => {
  const { openApply } = useLoanApply();
  return (
    <section
      style={{
        background: "#FFFFFF",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Header />

      {/* Heading + subtitle + buttons */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          paddingTop: "clamp(32px, 5.56vw, 80px)",
          paddingLeft: "clamp(20px, 5.56vw, 80px)",
          paddingRight: "clamp(20px, 5.56vw, 80px)",
          paddingBottom: "clamp(32px, 4.17vw, 60px)",
          gap: "clamp(20px, 2.78vw, 40px)",
        }}
      >
        {/* Heading + subtitle group */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "34px",
          }}
        >
          {/* Label */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#295B4A",
                flexShrink: 0,
                display: "inline-block",
              }}
            />
            <span
              style={{
                ...geistMono,
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "1",
                letterSpacing: "0.1em",
                color: "#295B4A",
                textTransform: "uppercase",
              }}
            >
              Loans
            </span>
          </div>

          <h1
            style={{
              ...instrumentSerif,
              fontWeight: 400,
              fontSize: "clamp(32px, 5.56vw, 80px)",
              lineHeight: 1.1,
              letterSpacing: "-0.01em",
              color: "#132A22",
              margin: 0,
              maxWidth: "min(700px, 100%)",
            }}
          >
            Flexible loans built for{" "}
            <span
              style={{
                ...instrumentSerif,
                fontStyle: "italic",
                color: "#295B4A",
              }}
            >
              growing
            </span>{" "}
            businesses.
          </h1>

          <p
            style={{
              ...raleway,
              fontWeight: 400,
              fontSize: "clamp(14px, 1.25vw, 18px)",
              lineHeight: "32px",
              color: "#5E5E5E",
              margin: 0,
              maxWidth: "min(733px, 100%)",
            }}
          >
            Get the funding you need to expand operations, restock inventory,
            manage cash flow, or take your next big step with confidence.
          </p>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", flexDirection: "row", gap: "12px" }}>
          <button
            type="button"
            onClick={() => openApply()}
            style={{
              ...raleway,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              height: "52px",
              padding: "0 16px",
              backgroundColor: "#86C7A8",
              border: "none",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "20px",
              color: "#132A22",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            Apply Now
          </button>

          <RouterLink
            to="/contact"
            style={{
              ...raleway,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              height: "52px",
              padding: "0 16px",
              backgroundColor: "transparent",
              border: "1px solid #DEDEDE",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "20px",
              color: "#132A22",
              textDecoration: "none",
              whiteSpace: "nowrap",
            }}
          >
            Speak to an Advisor
          </RouterLink>
        </div>
      </div>

      {/* Hero image */}
      <div
        style={{
          padding: "0 clamp(16px, 5.56vw, 80px) clamp(40px, 5.56vw, 80px)",
        }}
      >
        <img
          src={heroImage}
          alt="Business professionals in a meeting"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "12px",
            display: "block",
            objectFit: "cover",
          }}
        />
      </div>
    </section>
  );
};

export default LoanMain;
